export default "__VITE_ASSET__ZHNId_x4__"